import React,{useState,useEffect} from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate";
import Loader from "../loader/Loader";
const NCReviewReport = ({ show, handleClose, verifyId }) => {

    const [ncVerifications, setNcVerifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchNcVerifications = async () => {
        const token = getAuthToken();
        if (!token) return;

        try {
            setLoading(true);
            const response = await axios.get(
                `${config.API}/manager/verifyeffectiveactionget/${verifyId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data?.success) {
                setNcVerifications(response.data);
            }
        } catch (err) {
            console.error("Error fetching NC Verification", err);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (show && verifyId) fetchNcVerifications();
    }, [show, verifyId]);


    return (
        <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
          {
            loading ? (
                <Loader/>
            ) :(
                  <Modal.Body className="p-5">
                <h3 className="mb-3">Review Nc Report</h3>

                {/* NC Information Box */}
                <div className="p-3 border rounded bg-light mb-4">
                    <Row>
                        <Col md={6}>
                            <strong>Qty Inspected:</strong> {ncVerifications?.production?.nc_inspected ?? 0}
                        </Col>
                         <Col md={6}>
                            <strong>Qty Passed:</strong> {ncVerifications?.production?.nc_passed ?? 0}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <strong>Qty on Hold:</strong> {ncVerifications?.production?.nc_hold ?? 0}
                        </Col>
                        <Col md={6}>
                            <strong>Qty Rejected:</strong> {ncVerifications?.production?.nc_rejected ?? 0}
                        </Col>
                    </Row>
                </div>

                <Row>
                    <Col md={2}></Col>
                    <Col md={10}>
                        <Form.Group className="mt-4">
                            <Row>
                                <Col md={2}>
                                    <Form.Label>Notes</Form.Label>
                                </Col>
                                <Col md={10}>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                       value={ncVerifications?.production?.description}
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>
            </Modal.Body>
            )
          }

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default NCReviewReport;